import React from 'react'
import "./Cancle_btn.css"
import { Button } from 'react-bootstrap'

function Cancle_btn({ onClick, btnText }) {
    return (
        <>
            <Button className="Cancle_btn" type='button' onClick={onClick}>
                {btnText}
            </Button>
        </>
    )
}

export default Cancle_btn